"use client";

import Link from "next/link";
import { registrationEntries } from "../registration-entries";
import { useEffect, useRef, useState } from "react";
import { FilmStrip, MapTrifold, ArrowsLeftRight, CaretRight, User, X } from "@phosphor-icons/react";

export const merchantChoices = [
  { value: "director", title: "影视导演", description: "为 AI 短剧、影视项目挑选并批量申请形象授权", icon: FilmStrip },
  { value: "brand", title: "品牌电商", description: "为品牌代言、新品上市、电商大促、线下活动选角", icon: ArrowsLeftRight },
] as const;
export function MerchantChoices({ value, onChange, disabled = false }: { value: string | null; onChange: (value: "director" | "brand") => void; disabled?: boolean }) {
  return <div className="rg-merchant-choices" role="group" aria-label="厂商类型">{merchantChoices.map(choice => <button key={choice.value} type="button" disabled={disabled} aria-pressed={value === choice.value} onClick={() => onChange(choice.value)} className={`rg-merchant-choice ${value === choice.value ? "is-selected" : ""}`}>
    <span className="rg-choice-icon"><choice.icon size={22} /></span><span className="rg-merchant-copy"><strong>{choice.title}</strong></span><span className="rg-radio" aria-hidden="true" />
  </button>)}</div>;
}
function RegistrationWelcomeHeading({ dialog = false }: { dialog?: boolean }) {
  const Heading = dialog ? "h2" : "h1";
  return <div><Heading id={dialog ? "registration-choice-title" : undefined}>欢迎注册 Mirafans 镜界</Heading><p>请选择你的身份，开启形象资产合作</p></div>;
}
export function RegistrationWelcome() {
  return <section className="rg-identity-page"><div className="rg-choice-heading"><RegistrationWelcomeHeading /></div><div className="rg-identity-content"><RegistrationChoices /></div></section>;
}

export function RegistrationChoices({ onSelect }: { onSelect?: () => void }) {
  return <div className="rg-choices">
    {registrationEntries.map(choice => {
        const Icon = { creator: User, merchant: ArrowsLeftRight, agent: MapTrifold }[choice.kind];
        const body = <>
          <span className="rg-choice-top"><span className="rg-choice-icon"><Icon size={24} aria-hidden="true" /></span><span className="rg-choice-badge" aria-hidden="true">入驻</span></span>
          <h2>{choice.title}</h2>
          <div className="rg-choice-bottom"><p>{choice.description}</p><span className="rg-choice-arrow" aria-hidden="true"><CaretRight size={18} /></span></div>
        </>;
        return <Link key={choice.kind} href={choice.href} onClick={onSelect} className="rg-choice">{body}</Link>;
      })}
  </div>;
}
export function RegistrationEntry({ children, className, onOpen }: { children: React.ReactNode; className?: string; onOpen?: () => void }) {
  const [open, setOpen] = useState(false);
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    if (!open) return;
    const element = dialog.current;
    element?.showModal();
    return () => element?.close();
  }, [open]);
  return <><button type="button" className={className} onClick={() => { onOpen?.(); setOpen(true); }}>{children}</button>
    {open && <dialog ref={dialog} onCancel={() => setOpen(false)} onClick={event => { if (event.target === event.currentTarget) setOpen(false); }} aria-labelledby="registration-choice-title" className="onboarding-ui rg-choice-dialog">
      <div className="rg-choice-heading"><RegistrationWelcomeHeading dialog /><button type="button" aria-label="关闭注册身份选择" onClick={() => setOpen(false)} className="rg-close"><X size={20} /></button></div>
      <RegistrationChoices onSelect={() => setOpen(false)} /><button type="button" className="rg-cancel" onClick={() => setOpen(false)}>取消</button>
    </dialog>}
  </>;
}
